export const sidebarWidth = '370px';
